import { i as e } from "./cwc-widget.service-CDa-9kUr.js";
import { t } from "./cwc-window.service-DAyN_Bsf.js";
import { defineAsyncComponent as n } from "vue";
//#endregion
//#region src/lang/index.ts
var r = {
	en: {
		cwcWidgetApi: {
			createAlreadyExists: "The widget cannot be created because another widget with this ID already exists.",
			notFound: "Widget not found"
		},
		cwcWidgetList: {
			name: "Search for label or widget ID",
			loading: "Loading widget",
			headerLabel: "Title (internal)",
			headerCwcId: "Widget ID",
			headerWidgetType: "Widget type",
			headerCreatedAt: "Creation date",
			headerChangedAt: "Last modified date",
			filterWidgetType: "Widget type",
			allWidgetTypes: "All widget types"
		},
		cwcWidget: {
			selectorPlaceholder: "Select widget",
			cwcWidgetLabel: "Widget",
			configureWidget: "Configure widget",
			newWidget: "New widget",
			widgetTypeNotAllowed: "This widget type is not allowed.",
			widgetSaved: "Widget successfully saved",
			updateDownloadInPim: "Edit download in PIM"
		}
	},
	de: {
		cwcWidgetApi: {
			createAlreadyExists: "Dieses Widget kann nicht erstellt werden, weil bereits ein Widget mit dieser ID existiert.",
			notFound: "Widget nicht gefunden"
		},
		cwcWidgetList: {
			name: "Suchen nach Bezeichnung oder Widget-ID",
			loading: "Widget wird geladen",
			headerLabel: "Titel (intern)",
			headerCwcId: "Widget-ID",
			headerWidgetType: "Widget-Typ",
			headerCreatedAt: "Erstellungsdatum",
			headerChangedAt: "Änderungsdatum (Last modified)",
			filterWidgetType: "Widget-Typ",
			allWidgetTypes: "Alle Widget-Typen"
		},
		cwcWidget: {
			selectorPlaceholder: "Widget auswählen",
			cwcWidgetLabel: "Widget",
			configureWidget: "Widget konfigurieren",
			newWidget: "Neues Widget",
			widgetTypeNotAllowed: "Dieser Widget-Typ ist nicht erlaubt.",
			widgetSaved: "Widget erfolgreich gespeichert",
			updateDownloadInPim: "Download in PIM bearbeiten"
		}
	}
}, i = [{
	path: "/cwc-widget",
	children: [{
		path: "",
		name: "cwc_widget_list",
		component: () => import("./cwc-widget-list.view-C8a1-rgm.js").then((e) => e.n),
		meta: { requiredRight: "cwc-widgets:navigate" }
	}]
}], a = n(() => import("./cwc-widget-content-block-Dk_13aNz.js")), o = n(() => import("./cwc-widget-selector-DJfdKX4V.js")), s = n(() => import("./cwc-widget-channel-block-BBzK3ACe.js")), c = {
	messages: r,
	routes: i,
	contentBlocks: [{
		type: "CWC_WIDGET",
		label: "cwcWidget.cwcWidgetLabel",
		icon: "book",
		component: a,
		defaultValue: { type: "CWC_WIDGET" }
	}]
};
//#endregion
export { s as ChannelCwcWidgetBlock, a as CwcWidgetContentBlock, o as CwcWidgetSelector, c as cwcWidgetModule, e as getCwcCredentials, t as openWindowWithPostData };

//# sourceMappingURL=index.es.js.map